// components/slots-auto
/* global DEBUG */

import template  from './component.jade'


import Store     from 'Store'


let name = 'auto-list';
let url = '/api/AutoList';

const store = new Store(name);

export default {
    name: name,
    template: template(),

    data: () => ({
        url: url,
        name: name,
    }),

    events: {
        // при получении запроса вернем список слотов
        ['auto-list:' + name]: function (data) {
            this.$set('data', null);
            this.$set('data', data);
            this.$set('data', store.$get(this))
        },
    },
}



/** WEBPACK FOOTER **
 ** ./src/js/components/auto-list/component.js
 **/